$("#statistic-categories").each(function () {
    let $wrap = $(this)

    $wrap.find('[data-bs-toggle="collapse"]').on('click', function (e) {
        setTimeout(function () {
            if ($(e.currentTarget).attr('aria-expanded') !== 'true') {
                history.replaceState({}, "", ' ')
            } else {
                history.replaceState({}, "", $(this).attr('href'))
            }
        }.bind(this), 100)
    })

    $wrap.find(".accordion-button[data-bs-target]").click(function () {
        setTimeout(function () {
            if ($(this).hasClass('collapsed')) {
                var $closestAcc = $(this).closest('.accordion-collapse')
                var $closestCollapse = $(this).closest('.collapse')
                if ($closestAcc.length) {
                    history.replaceState({}, "", '#' + $closest[0].id)
                } else if ($closestCollapse.length) {
                    history.replaceState({}, "", '#' + $closestCollapse[0].id)
                } else {
                    history.replaceState({}, "", ' ')
                }

            } else {
                history.replaceState({}, "", $(this).data('bs-target'))
            }
        }.bind(this), 100)
    })

    if (window.location.hash) {
        setTimeout(function () {
            let $accordionCollapse = $(window.location.hash + ".accordion-collapse")
            let $rootCollapse = $(window.location.hash + ".collapse")

            if ($accordionCollapse.length) {
                openAccordion($accordionCollapse[0])
            } else if ($rootCollapse) {
                bootstrap.Collapse.getOrCreateInstance(
                    $rootCollapse[0]
                ).show()
            }
        }, 0);
    }

    function openAccordion(container) {

        $(container).parent().closest('.accordion-collapse').each(function () {
            openAccordion(this)
        });

        $(container).parent().closest('.collapse').each(function () {
            bootstrap.Collapse.getOrCreateInstance(
                this
            ).show()
        });

        bootstrap.Collapse.getOrCreateInstance(
            container
        ).show()
    }
})

function toggleCatalogInfoMessage() {
    if ($('#subcategories-wrap .collapse.show').length === 0) {
        $('#catalog_info').show();
    } else {
        $('#catalog_info').hide();
    }
}

toggleCatalogInfoMessage();
$('#subcategories-wrap .collapse').on('shown.bs.collapse hidden.bs.collapse', function () {
    toggleCatalogInfoMessage();
});

$('.card-link[data-bs-toggle="collapse"]').on('click', function () {
    $('#catalog_info').hide();
});

// //Mobile version for statistic indicators
$(function () {
    const $mainSelect = $('#main-category');
    const $level2Container = $('#level-2-container');
    const $level2Select = $('#level-2');

    const $level3Container = $('#level-3-container');
    const $level3Select = $('#level-3');

    const $cardsContainer = $('#cards-container');
    const $cardsOutput = $('#cards-output');
    const $catalogInfo = $('#catalog_info');
    const $noIndicators = $('#no-indicators-message');

    function updateCatalogInfoVisibility() {
        const isSelected = Boolean($mainSelect.val());
        $catalogInfo.toggle(!isSelected);
    }

    function showNoIndicatorsMessage(condition) {
        $noIndicators.toggle(condition);
    }

    function renderOptions($select, items, placeholder) {
        $select.empty().append(
            `<option value="" disabled selected hidden>${placeholder}</option>`
        );

        items.forEach(item => {
            const dataAttrs = [];

            if (item.children) {
                dataAttrs.push(`data-children='${JSON.stringify(item.children)}'`);
            }

            if (item.tables) {
                dataAttrs.push(`data-tables='${JSON.stringify(item.tables)}'`);
            }

            $select.append(`<option value="${item.id}" ${dataAttrs.join(' ')}>${item.title}</option>`);
        });
    }

    function renderCards(tables) {
        $cardsOutput.empty();

        if (!Array.isArray(tables) || tables.length === 0) {
            $cardsContainer.hide();
            return;
        }

        tables.forEach(table => {
            $cardsOutput.append(`
                <div class="col-12 mb-2">
                    <a href="${table.url}" class="card d-block p-3 text-decoration-none text-dark">
                        ${table.title}
                    </a>
                </div>`);
        });

        $cardsContainer.show();
    }

    $('#statistic-categories .select2').select2({
        minimumResultsForSearch: Infinity,
        allowClear: false
    });

    $mainSelect.on('change', function () {
        const selected = $(this).find(':selected');
        const level2Items = selected.data('children') || [];

        renderOptions($level2Select, level2Items, 'Pasirinkite subkategoriją');
        $level2Container.toggle(level2Items.length > 0);

        renderOptions($level3Select, [], 'Pasirinkite rodiklį');
        $level3Container.hide();
        $cardsOutput.empty();
        $cardsContainer.hide();

        updateCatalogInfoVisibility();
        showNoIndicatorsMessage(level2Items.length === 0);
    });

    $level2Select.on('change', function () {
        const selected = $(this).find(':selected');
        const level3Items = selected.data('children') || [];
        const tables = selected.data('tables') || [];

        renderOptions($level3Select, level3Items, 'Pasirinkite rodiklį');
        $level3Container.toggle(level3Items.length > 0);

        $cardsOutput.empty();
        $cardsContainer.hide();

        if (level3Items.length === 0 && tables.length > 0) {
            renderCards(tables);
            showNoIndicatorsMessage(false);
        } else {
            showNoIndicatorsMessage(level3Items.length === 0);
        }
    });

    $level3Select.on('change', function () {
        const selected = $(this).find(':selected');
        const tables = selected.data('tables') || [];

        renderCards(tables);
        showNoIndicatorsMessage(tables.length === 0);
    });

    const hash = window.location.hash;
    const categoryIdFromHash = hash && hash.match(/-(\d+)$/) ? hash.match(/-(\d+)$/)[1] : null;

    if (categoryIdFromHash) {
        setTimeout(() => {
            const $option = $mainSelect.find(`option[value="${categoryIdFromHash}"]`);
            if ($option.length) {
                $mainSelect.val(categoryIdFromHash).trigger('change');
            }
        }, 100);
    }

    // Trigger on load
    updateCatalogInfoVisibility();
});
